import { useState, useEffect } from "react";
import TapSelect from "../../components/ui/TapSelect";
import { toast } from "react-toastify";
import { withRouter } from "react-router-dom";
import TapIcon from "../../services/TapIcon";
import { useSelector } from "react-redux";
import TapInput from "../../components/ui/TapInput";

const CommonSearch = ({ history, location }) => {

    const allSearchSelects = [
        { value: "measurable_asset", label: "Asset", permission: null },
        { value: "task_transaction_list", label: "Task", permission: 'iam-asset-task-delete' },
        { value: "ticket", label: "Ticket", permission: null },
        { value: "item_list", label: "Item", permission: 'isc-item-view' },
        { value: "warehouse_indent_list", label: "Indent", permission: 'isc-warehouse-indent-view' },
        { value: "requisition_list", label: "Requisition", permission: 'isc-purchase-requisition-view' },
        { value: "purchase_order_list", label: "PO", permission: 'isc-po-view' },
        { value: "purchase_list", label: "Purchase", permission: 'isc-purchase-view' },
        { value: "purchase_return_list", label: "Purchase Return", permission: 'isc-purchase-return-view' },
        { value: "item_demand_list", label: "Item Demand", permission: 'isc_item_demand_view' },
        { value: "allocation_list", label: "Allocation", permission: 'isc-allocation-view' },
        { value: "consumption_list", label: "Consumption", permission: 'isc-consumption-view' },
        { value: "inventory_transfer_list", label: "Inventory Transfer", permission: 'isc-inventory_transfer-view' },
        { value: "inventory_adjustment_list", label: "Inventory Adjustment", permission: 'isc-inventory-adjustment-view' },
        { value: "logistic_list", label: "Logistic", permission: 'logistic_view' },
        { value: "project", label: "Project", permission: 'iam-project-view' },
        { value: "project_ticket", label: "Project Ticket", permission: 'iam-project-view' },
        { value: "customer_list", label: "Customer", permission: 'customer-project-view' },
        { value: "warehouse", label: "Warehouse", permission: 'iam-asset-task-delete' },
        { value: "vendor", label: "Vendor", permission: 'vendor-view' },
        { value: "employee_list", label: "Employee", permission: 'hrm-employee-view' },

    ];
    const permissions = useSelector(state => state.app.acl_info && state.app.acl_info.permissions ? state.app.acl_info.permissions : []);

    const searchSelects = allSearchSelects.filter(option =>

        !option.permission || permissions.includes(option.permission)
    );

    const [searchText, setSearchText] = useState('');
    const [url, setUrl] = useState('');

    useEffect(() => {
        const { searchText, url } = location.state || {};
        if (searchText) setSearchText(searchText);
        if (url) setUrl(url);
    }, [location.state]);

    const handleGoClick = () => {
        if (searchText && url) {
            history.push({
                pathname: '/' + url,
                search: `?searchText=${encodeURIComponent(searchText)}`,
                state: { searchText, url }
            });
        } else {
            toast.error("Please enter search text and select an option.");
        }
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleGoClick();
        }
    };

    return (
        <>
            <div className="d-flex align-items-center">
                <TapSelect
                    width="120px"
                    defaultValue="1"
                    options={searchSelects}
                    isSearchable={true}
                    containerHeight="35px"
                    fontSize="93%"
                    placeholder="Select"
                    value={searchSelects.find(r => r.value === url) || null}
                    changeEvent={(selectedOption) => {
                        setUrl(selectedOption ? selectedOption.value : '');
                    }}
                />
                <div className="d-flex search_input_width" style={{ marginLeft: "-5px" }}>
                    <TapInput
                        value={searchText}
                        className="form-control fs12"
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyDown={handleKeyDown}
                        placeholder="Please Enter"
                        style={{
                            height: "35px", borderRadius: "0px",
                            padding: "6px 12px",
                            color: "rgba(0, 0, 0, 1)",
                            fontFamily: "Roboto",
                            fontSize: "14px",
                            border: "1px solid #d6dedc",
                            background: "#FFF 0% 0% no-repeat padding-box",
                            width:"100%"
                        }}
                    />
                    <TapIcon.FontAwesomeIcon style={{ height: "35px", marginLeft: "-25px", color: "green", cursor: "pointer" }} onClick={handleGoClick} icon={TapIcon.faSearch} />
                </div>
            </div>
        </>
    );
};

export default withRouter(CommonSearch);
